<template>
  <div class="row col-md-12">
    from
      <datepicker class="col-md-5"
        v-model="start"
        :clear-button="true" clear-button-icon="fa fa-times"
        :calendar-button="true" calendar-button-icon="fa fa-calendar"
        inputClass="dateinput" :bootstrapStyling="true"
        @input="onInput"
      />
    to
      <datepicker class="col-md-5"
        v-model="end"
        :clear-button="true" clear-button-icon="fa fa-times"
        :calendar-button="true" calendar-button-icon="fa fa-calendar"
        inputClass="dateinput" :bootstrapStyling="true"
        @input="onInput"
      />

  </div>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'DateRange',
  components: {Datepicker},
  props: {
    value: {default: null}
  },
  data () {
    // console.log('DateRange.data', this.value)
    return {
      start: null,
      end: null
    }
  },
  watch: {
    value (v) {
      console.log('DateRange.watch.value', this.value, v)
      if (v === null) {
        this.start = this.end = null
      }
    }
  },
  methods: {
    onInput () {
      let result = ''
      if (this.start) result += moment(this.start).format('YYYY-MM-DD')
      result += '|'
      if (this.end) result += moment(this.end).format('YYYY-MM-DD')
      this.$emit('input', result)
    }
  }
}
</script>



// WEBPACK FOOTER //
// DateRange.vue?53545d99